export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()

    const $customFetch = $fetch.create({
        baseURL: config.public.api.path,
    })

    const $acseFetch = $fetch.create({
        baseURL: config.public.api.acse_path,
    })

    const $prometheusFetch = $fetch.create({
        baseURL: config.public.api.prometheus_path,
    })

    return {
        provide: {
            customFetch: $customFetch,
            acseFetch: $acseFetch,
            prometheusFetch: $prometheusFetch,
        },
    }
})
